<template>
  <nav
    class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg bg-green"
    color-on-scroll="100"
    style="background-color:none"
    id="sectionsNav"
  >
    <div class="container-fluid">
      <div
        class="collapse navbar-collapse"
        style="background: none; padding: 11.2px; "
      >
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link to="/">
              <img
                src="../../public/assets/img/logo.png"
                style="background: #06373d;"
                class="d-block d-sm-none img-fluid w-100"
              />

              <img
                src="../../public/assets/img/logo.png"
                style="width:130px;"
                class="d-none d-sm-block"
              />
            </router-link>
          </li>
        </ul>
        <ul class="navbar-nav mr-auto ml-auto">
          <!-- <form class="form-inline d-md-none d-lg-block d-sm-none d-md-block d-lg-none d-xl-block">
                        <div class="form-group has-white">
                          <input type="text" class="form-control" placeholder="Search" />
                        </div>
                        <button type="submit" class="btn btn-white btn-raised btn-fab btn-round">
                          <i class="material-icons">search</i>
                        </button>
                    </form>-->

          <li class="nav-item">
            <router-link
              to="/membership-application"
              class="nav-link font-weight-bold"
              >Become A Member</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/activities" class="nav-link font-weight-bold"
              >Activities</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/contact-us" class="nav-link font-weight-bold"
              >Contact Us</router-link
            >
          </li>

          <li class="nav-item">
            <router-link to="/scholarship" class="nav-link font-weight-bold"
              >Apply for scholarship</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/glit-award"
              class="nav-link font-weight-bold"
              style="font-size: 18px;"
            >
              <i class="fa fa-certificate" />GLIT AWARD</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/glit-registration"
              class="nav-link font-weight-bold"
              style="font-size: 18px;"
              ><i class="fa fa-book" />GLIT REGISTRATION</router-link
            >
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item text-center">
            <router-link
              to="/membership-application"
              class="btn btn-orange pt-2 pb-2"
              style="border-radius: 10px;"
            >
              Apply now
            </router-link>
          </li>
        </ul>
      </div>
      <div class="navbar-translate">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
          <span class="navbar-toggler-icon" />
        </button>
      </div>
    </div>
  </nav>
</template>
<script>
import $ from "jquery";

export default {
  name: "navbar",
  data() {
    return {};
  },
  computed: {
    activeUserInfo() {
      return this.$store.getters.loggedIn;
    }
  },
  methods: {
    scrollToSection(section) {
      this.$nextTick(() => {
        $("html, body").animate(
          {
            scrollTop: $(section).offset().top - 200
          },
          1000
        );
      });
    },
    logout() {
      this.$store.dispatch("destroyToken").then(() => {
        // if (res.success) {
        //   this.$router.push("/");
        // }
      });
    }
  }
};
</script>

<style scoped>
.navbar {
  color: white;
  background-color: #06373d !important;
}
.navbar-toggler-icon {
  background-color: white !important;
}
</style>
